
<template>
  <div>
    <v-dialog v-model="dialog" persistent transition="dialog-bottom-transition" scrollable width="600px">
      <v-card v-if="dialog">
        <v-card-title primary-title class="pa-0">
          <v-toolbar dark color="primary" >
            <v-toolbar-title>Nova categoria</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="$emit('closeEditDialog')" dark>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text v-if="edit_category">
          <v-form ref="editForm">
            <v-text-field label="Nome" v-model="edit_category.name" :rules="required"></v-text-field>
            <v-text-field label="Código" v-model="edit_category.code" type="number" :rules="required"></v-text-field>
            <v-text-field label="Referência" v-model="edit_category.percent_ref" type="number" :rules="required"></v-text-field>
            <v-select label="Tipo" :items="kind_options" v-model="edit_category.kind" :rules="required" item-value="value" item-text="name"></v-select>
            <v-textarea label="Descrição" v-model="edit_category.description"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn color="success" @click="editCategory()"><v-icon left>mdi-check</v-icon>Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import validations from '@/mixins/validations';

export default {
  name: 'EditCategoryDialog',
  props: {
    category: {
      type: Object,
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    validations
  ],
  data() {
    return {
      edit_category: null,
      kind_options: [
        {
          name: 'Produtivo',
          value: 'P'
        },
        {
          name: 'Improdutivo',
          value: 'I'
        }
      ]
    }
  },
  mounted () {
    this.setEditCategory();
  },
  methods: {
    setEditCategory() {
      let {json_attributes, ...cat} = this.category;
      this.edit_category = {...cat, ...json_attributes}
      console.log(this.edit_category)
    },
    editCategory() {
      if (this.$refs.editForm.validate()) {
        this.edit_category.percent_ref = Number(Number(this.edit_category.percent_ref).toFixed(1))
        this.updateCategory(this.edit_category).then(() => {
          this.$emit('closeEditDialog')
        })
      }
    },
    ...mapActions({
      updateCategory: 'Category/update'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>